import { Controller } from "@hotwired/stimulus";

// <dialog> 要素の表示制御。コンテンツ取得は Turbo Frame が担当する。
// 閉じるボタンは data-close-dialog 属性で識別（動的コンテンツ対応のためイベント委譲）。
export class RewardModalController extends Controller {
  static targets = ["dialog"];

  show() {
    this.dialogTarget.showModal();
  }

  handleClick(event) {
    if (event.target.closest("[data-close-dialog]")) {
      this.dialogTarget.close();
      return;
    }
    // backdrop（ダイアログ自体）クリックで閉じる
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close();
    }
  }

  // ダイアログが閉じたらフレーム内のコンテンツをクリアする
  // （非表示状態でも DOM に残ると意図しない描画が起きるため）
  dialogTargetConnected(element) {
    element.addEventListener("close", () => {
      const frame = element.querySelector("turbo-frame");
      if (frame) frame.innerHTML = "";
    });
  }
}
